const readCode = (value: unknown): string | undefined => {
  if (Array.isArray(value)) return readCode(value[0])
  if (
    value &&
    typeof value === 'object' &&
    'type' in value &&
    value.type === 'LIST'
  )
    return 'label' in value ? readCode(value.label) : undefined
  if (value && typeof value === 'object' && 'value' in value)
    return readCode(value.value)
  return typeof value === 'string' && /^[a-z]{3}$/i.test(value)
    ? value.toUpperCase()
    : undefined
}

export function readProductCurrency(
  row?: Record<string, unknown> | null,
): string {
  const property = Array.isArray(row?.properties)
    ? row.properties.find((item) => item?.key === 'price.currency')
    : undefined
  const nested =
    row?.price && typeof row.price === 'object' && 'currency' in row.price
      ? row.price.currency
      : undefined
  const cell = row?.['price.currency']
  const firstCell = Array.isArray(cell) ? cell[0] : cell
  const listCode =
    firstCell && typeof firstCell === 'object' && firstCell.type === 'LIST'
      ? readCode(firstCell)
      : undefined
  return (
    listCode ??
    // LIST properties store option IDs; the currency code lives in the label/nested price.
    readCode(property?.type === 'LIST' ? undefined : property?.values) ??
    readCode(cell) ??
    readCode(nested) ??
    'EUR'
  )
}
